import { render } from "./DownloadIcon.vue?vue&type=template&id=3245a2ec&scoped=true&ts=true"
import script from "./DownloadIcon.vue?vue&type=script&lang=ts"
export * from "./DownloadIcon.vue?vue&type=script&lang=ts"

import "./DownloadIcon.vue?vue&type=style&index=0&id=3245a2ec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3245a2ec"]])

export default __exports__